import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import { CollectionFunctionMenuActionsType } from 'routes/CollectionFunction/CollectionFunction.types';
import ModalDialog from 'shared/modal/dialog';
import { CollectionFunction } from 'data/collectionFunction/collectionFunction.types';
import './collection-function-list-menu.scss';

type Props = {
  selectedCollectionFunction?: CollectionFunction;
  hasPrivilegeToCreateNew: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onCopy: ()=> void;
  onDelete: ()=> void;
}

const CollectionFunctionListMenu: FunctionComponent<Props> = ({
  selectedCollectionFunction,
  hasPrivilegeToCreateNew,
  hasPrivilegeToDelete,
  onEdit,
  onCopy,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedCollectionFunction == null) {
    return null;
  }

  return (
    <div data-testid="CollectionFunctionListMenu" className="collection-function-list-menu">
      {hasPrivilegeToCreateNew && (
      <Button
        className="collection-function-list-menu-button"
        data-testid={`${CollectionFunctionMenuActionsType.Edit}-button`}
        text={t('collectionFunction.grid.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToCreateNew && (
      <Button
        className="collection-function-list-menu-button"
        data-testid={`${CollectionFunctionMenuActionsType.Copy}-button`}
        text={t('collectionFunction.grid.copy')}
        onClick={onCopy}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="collection-function-list-menu-button"
        data-testid={`${CollectionFunctionMenuActionsType.Delete}-button`}
        text={t('collectionFunction.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('collectionFunction.deletePopup.title')}
        displayMessage={t('collectionFunction.deletePopup.message', { name: selectedCollectionFunction.name })}
        actionText={t('collectionFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>

  );
};

export default CollectionFunctionListMenu;
